import script from "./support.vue?vue&type=script&lang=ts&setup=true"
export * from "./support.vue?vue&type=script&lang=ts&setup=true"

import "./support.vue?vue&type=style&index=0&id=0a892638&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a892638"]])

export default __exports__